import { useMemo, useRef } from 'react';
import { get } from 'lodash';
import { shallowEqual, useSelector } from 'react-redux';

import { getCurrentLeg } from '../../../selectors/screen';
import { getTelexInfo } from '../../../selectors/telegrams';

export const useTelegramData = () => {
    const { telegrams, ofps, currentOfpId } = useSelector((state) => {
        const {
            screen: { currentLeg },
            sendedData,
        } = state;
        const leg = getCurrentLeg(state) || {};
        const ofpId = get(sendedData[currentLeg], 'ofpId');
        const { telegramList } = getTelexInfo(state);

        return {
            telegrams: telegramList,
            ofps: get(leg, 'ofps'),
            currentOfpId: ofpId,
        };
    }, shallowEqual);

    const ofp = useMemo(() => {
        const ofpId = currentOfpId;
        const ofp = ofps ? Object.values(ofps).find((ofp) => ofp.id === +ofpId) : null;

        return ofp;
    }, [currentOfpId, ofps]);

    const ofpRef = useRef(ofp);

    return {
        ofp,
        ofpRef,
        telegrams,
    };
};
